import { MutationTree } from 'vuex';
import { DirectDebitState } from './types';
import directDebit, { DirectDebit } from '@/shared/model/directDebit';
import creditTransfer, { CreditTransfer } from '@/shared/model/creditTransfer';

export const mutations: MutationTree<DirectDebitState> = {
  setDirectDebit(state, payload?: DirectDebit) {
    state.directDebit = directDebit.parse(payload);
  },
  clearDirectDebit(state) {
    state.directDebit = undefined;
  },
  setCreditTransferForTrainers(state, payload?: CreditTransfer) {
    state.creditTransferForTrainers = creditTransfer.parse(payload);
  },
  clearCreditTransferForTrainers(state) {
    state.creditTransferForTrainers = undefined;
  },
};
